import React, {useEffect, useState} from 'react';
import cx from 'classnames';
import {H2} from '../../../components/crousal/Headings';
import {Button, ButtonSize, ButtonType} from '../../../components/crousal/Button';
import {ISkinsAndChampions} from '../../../common/types/SkinsAndChampions';
import {SKINS_AND_CHAMPION} from '../../../common/constants/skinsAndChampions';
import {TextInput} from '../../../components/crousal/TextInput';
import {Pagination} from '../Pagination';

interface IProps {
    onChange: (step: number) => void;
    skinsAndChampions: ISkinsAndChampions[];
}

export function Step2({onChange, skinsAndChampions}: IProps) {
    const [mode, setMode] = useState(SKINS_AND_CHAMPION.champion);
    const [currentPage, setCurrentPage] = useState(1);
    const [skinsAndChampionsPerPage] = useState(40);
    const indexOfLastSkinsAndChampionsPage = currentPage * skinsAndChampionsPerPage;
    const indexOfFirstSkinsAndChampionsPage = indexOfLastSkinsAndChampionsPage - skinsAndChampionsPerPage;

    // set default type as champion
    const skinsChampionsAndIconsArray = skinsAndChampions.filter(item => item.type === SKINS_AND_CHAMPION.champion);
    const [totalPages, setTotalPages] = useState(Math.ceil(skinsChampionsAndIconsArray.length / skinsAndChampionsPerPage));

    // show only limited records per page
    const [currentSkinsChampionsAndIconsArray, setCurrentSkinsChampionsAndIconsArray] = useState(
        skinsChampionsAndIconsArray.slice(indexOfFirstSkinsAndChampionsPage, indexOfLastSkinsAndChampionsPage)
    );
    const [searchString, setSearchString] = useState('');

    function handleSelect() {
        onChange(3);
    }

    function changeMode(newMode: string) {
        setMode(newMode);
        getFilteredSkinsChampionsAndIconsArray(newMode);
    }

    useEffect(() => {
        setCurrentSkinsChampionsAndIconsArray(
            filteredArrayBasedOnMode(mode).slice(
                indexOfFirstSkinsAndChampionsPage,
                indexOfLastSkinsAndChampionsPage
            )
        );
    }, [currentPage]);

    useEffect(() => {
        getFilteredSkinsChampionsAndIconsArray(mode);
    }, [searchString]);

    function getFilteredSkinsChampionsAndIconsArray(modeToFilter: string) {
        setCurrentSkinsChampionsAndIconsArray(
            filteredArrayBasedOnMode(modeToFilter).slice(
                indexOfFirstSkinsAndChampionsPage,
                indexOfLastSkinsAndChampionsPage
            )
        );

        setTotalPages(Math.ceil(filteredArrayBasedOnMode(modeToFilter).length / skinsAndChampionsPerPage));
    }

    function filteredArrayBasedOnMode(modeToFilter: string) {
        return skinsAndChampions.filter(
            item => {
                const nameMatch = item.name ? item.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1 : null;
                const type = item.type === modeToFilter;

                return item.type === SKINS_AND_CHAMPION.icon ? type : nameMatch && type;
            });
    }

    return (
        <div>
            <H2 className="mt-6 lg:mt-10">Step 2 - Describe your account</H2>
            <p className="text-left mt-6 lg:w-3/5 lg:mx-auto">
                Game
            </p>
            <div className="text-left mt-6 lg:w-3/5 lg:mx-auto">
                <img
                    className="p-4 bg-smurfs-gold h-16"
                    src={"/images/unrankedsmurfs-login/LoL.png"}
                    alt={"League of Legends"}
                />
            </div>
            <p className="text-left mt-6 lg:w-3/5 lg:mx-auto">
                Collectables
            </p>

            <div className="mt-4 text-md flex lg:w-3/5 lg:mx-auto">
                <p
                    className={cx(
                        "text-left cursor-pointer",
                        mode === SKINS_AND_CHAMPION.champion ? 'text-medal-gold' : 'text-40',
                    )}
                    onClick={() => changeMode(SKINS_AND_CHAMPION.champion)}
                >
                    Champions
                </p>
                <p
                    className={cx(
                        "ml-10 cursor-pointer",
                        mode === SKINS_AND_CHAMPION.skin ? 'text-medal-gold' : 'text-40',
                    )}
                    onClick={() => changeMode(SKINS_AND_CHAMPION.skin)}
                >
                    Skins
                </p>
                <p
                    className={cx(
                        "ml-10 cursor-pointer",
                        mode === SKINS_AND_CHAMPION.icon ? 'text-medal-gold' : 'text-40',
                    )}
                    onClick={() => changeMode(SKINS_AND_CHAMPION.icon)}
                >
                    Icons
                </p>
            </div>

            <div
                className="mt-4 justify-center items-center text-center lg:w-3/5 lg:mx-auto p-4 bg-medium-black">
                {
                    mode === SKINS_AND_CHAMPION.icon ? null : <TextInput
                        value={searchString}
                        onChange={setSearchString}
                        placeholder={"Type something to Search"}
                        isSearch={true}
                        className={'bg-mid-black'}
                    />
                }

                <div
                    className={cx('mt-4', currentSkinsChampionsAndIconsArray.length === 0 ? '' : "flex-1 flex flex-wrap text-left")}>
                    {currentSkinsChampionsAndIconsArray.length === 0 ?
                        (
                            <div className="justify-center items-center">
                                <div className="mr-4">
                                    <img src="/images/misc/teemo_crying.gif" alt="unrankedsmurfs teemo crying"/>
                                </div>
                                <div className="flex flex-col">
                                    <span className="heading-4 heading-gold">NOTHING FOUND</span>
                                    <span>Please adjust your filter and try again.</span>
                                </div>
                            </div>
                        )
                        :
                        (
                            currentSkinsChampionsAndIconsArray.map(({type, name, image_url, rare, url}, index) => {
                                return (
                                    <div key={index} className="flex-col pl-4 mt-4 w-1/5">
                                        <a
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <div className="flex">
                                                <div className="w-10">
                                                    <img src={image_url} className={"h-8"} alt={"image"}/>
                                                </div>
                                                <div className="leading-xxs">
                                                    <p className="text-xs ml-2">{name}</p>
                                                    <p className="text-xxs ml-2 text-40">{type ? type.toUpperCase() : null}</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })
                        )
                    }
                </div>
                <Pagination totalPages={totalPages} onChange={setCurrentPage}/>
            </div>

            <div className="text-sm mt-6 items-center flex justify-center text-center">
                <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={handleSelect}>
                    Next
                </Button>
            </div>
        </div>
    );
}
